export default {
    beforeDestroy() {
        Object.assign(this.$data, {});
    }
};
